import { triggerEvent, triggerPageView } from './analytics';

function getCellDetail($cell) {
	let details;
	const values = [
		() => $cell.find('figcaption').text().trim(),
		() => $cell.find('img').attr('alt'),
		() => {
			const imgSrc = $cell.find('img').attr('src');
			return imgSrc ? imgSrc.split('/').pop() : '';
		},
		() => $cell.find('div.ThirdPartyVideo').next('p').text().trim(),
		() => $cell.find('div.ThirdPartyVideo').data('src'),
	];

	// Go through the functions until getting a truthy value
	while (!(details = values.shift()()) && values.length);
	return details;
}

const transition = payload => {
	var cellDetail = getCellDetail(payload.cell);
	if (utag_data && utag_data.page_name && utag_data.page_name.indexOf(':residences') > -1) {
		triggerEvent('residences', 'image carousel click', cellDetail);
	} else {
		triggerEvent('gallery', 'Hero gallery click', cellDetail);
	}
};

const open = payload => {
	triggerPageView({
		page_detail: payload.element.data('analytics-detail') || 'gallery',
	});
};

export default {
	open,
	transition,
};
